// Proof for POST /v3/reservation-web/submit-waiver/:user_id (razor-backend#1569). The server refuses a
// waiver submission unless the caller shows a waiver token minted for that rider. Two places hand
// one over:
//   - a waiver link razor emailed or texted carries ?waiver_token=  (kept here per user, per tab)
//   - a phone or email code login returns it on the user object      (stored with `user`)
// A token is spent by the submission it authorizes, so it is forgotten after a successful submit.

const sessionKey = (userId) => `waiver_token_${userId}`;

const safely = (fn, fallback = null) => {
  try {
    return fn();
  } catch {
    return fallback;
  }
};

export const rememberWaiverTokenFromUrl = (search, userId) => {
  const token = new URLSearchParams(search || '').get('waiver_token');
  if (token && userId) safely(() => sessionStorage.setItem(sessionKey(userId), token));
  return token || null;
};

const storedUser = () => safely(() => JSON.parse(localStorage.getItem('user') || 'null'));

export const getWaiverToken = (userId) => {
  if (!userId) return null;
  const fromLink = safely(() => sessionStorage.getItem(sessionKey(userId)));
  if (fromLink) return fromLink;
  const user = storedUser();
  if (user && String(user.id || user.user_id) === String(userId) && user.waiver_token) return user.waiver_token;
  return null;
};

export const forgetWaiverToken = (userId) => {
  safely(() => sessionStorage.removeItem(sessionKey(userId)));
  const user = storedUser();
  if (user && String(user.id || user.user_id) === String(userId) && user.waiver_token) {
    delete user.waiver_token;
    safely(() => localStorage.setItem('user', JSON.stringify(user)));
  }
};
